export function hexToHsl(hex: string): [number, number, number] {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;

  if (max === min) return [0, 0, l];

  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  let h = 0;
  if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
  else if (max === g) h = ((b - r) / d + 2) / 6;
  else h = ((r - g) / d + 4) / 6;

  return [h * 360, s * 100, l * 100];
}

function hslToHex(h: number, s: number, l: number): string {
  s /= 100;
  l /= 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n: number) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * Math.max(0, Math.min(1, color)))
      .toString(16)
      .padStart(2, '0');
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

/**
 * Generate Tailwind-style color shades (50–900) from a single hex color.
 * The input hex is treated as the 600 shade.
 */
export function generateColorShades(hex: string): Record<string, string> {
  const [h, s] = hexToHsl(hex);

  // Lightness targets matching Tailwind's default distribution
  const shades: Record<string, number> = {
    '50': 96,
    '100': 92,
    '200': 84,
    '300': 72,
    '400': 58,
    '500': 46,
    '600': 38,
    '700': 30,
    '800': 24,
    '900': 18,
  };

  const result: Record<string, string> = {};
  for (const [shade, lightness] of Object.entries(shades)) {
    result[shade] = hslToHex(h, Math.min(s, 95), lightness);
  }
  return result;
}
